import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, UntypedFormBuilder } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { DataTableHeaderOption } from '@dxo/ng-swift-ui';
import { DropdownOption } from '@benefitsui/app/lib/common.types';
import { BillingFancyService } from '../billing-fancy.service';
import { BillingFancyPageComponent } from '../billing-fancy-page.component';
import { CellItemType, DueDateObj, PremiumCalcObj } from '../billing-fancy-page.types';
import { Constants } from '@benefitsui/app/pages/billing-fancy-page/billing-fancy-page.types';
import { Defaults } from '@benefitsui/app/shared/defaults/defaults';
import { formatActiveEnvironmentDocumentLink } from '@benefitsui/app/shared/activeenvironment/activeenvironment';
import { SearchSortDirection, SearchSortField } from '@benefitsui/app/api/benefits-clients';
import { UserContextService } from '@benefitsui/app/services/user-context/user-context.service';
import { UserContext } from '@benefitsui/app/services/user-context/user-context.types';

@Component({
  selector: 'app-billing-statements-list',
  templateUrl: './statements-list.component.html',
  styleUrls: ['./statements-list.component.scss'],
  standalone: false,
  providers: [UserContextService]
})
export class BillingFancyStatementsListComponent implements OnInit {
  // :  Constants
  ActionsText = Constants.ActionsText;
  billGroup = Constants.BillGroup;
  invoicePeriod = Constants.invoicePeriod;
  InvoicePeriodAndNumberText = Constants.InvoicePeriodAndNumberText;
  RunDateText = Constants.RunDateText;
  SortKey = Constants.SortKey;
  dueDate = Constants.dueDate;
  amountBalance = Constants.amountBalance;
  premiumCalc = Constants.premiumCalc;
  statementNumber = Constants.statement;
  isAscending = true;


  // :  Data members
  formGroup: FormGroup;

  tableHeaders: DataTableHeaderOption[];
  userContext: UserContext;
  userType: string;
  invoicePeriodOptions: DropdownOption<string>[] = [];
  isEmployee: boolean = false;
  billGroupNumberOptions: DropdownOption<string>[] = [];
  StatusOptions: DropdownOption<string>[] = [
    { key: 'Paid', displayName: 'Paid' },
    { key: 'Unpaid', displayName: 'Unpaid' }
  ];
  SortDirection = SearchSortDirection;
  private pageSize$ = new BehaviorSubject<number>(10);
  private sortDirection$ = new BehaviorSubject<SearchSortDirection>(SearchSortDirection.Descending);
  sortField$ = new BehaviorSubject<SearchSortField>(SearchSortField.Invoice);
  isLoading = true;
  tableCells!: CellItemType[];
  hasServerError = false;
  searchParameter = {
    status: Defaults.stringEmpty,
    billGroupNumber: Defaults.stringEmpty,
    invoicePeriod: undefined,
    invoicePeriodString: undefined,
    page: 1,
    pageSize: 10,
    sortField: 'dueDate',
    sortDirection: SearchSortDirection.Descending
  };
  private page$ = new BehaviorSubject<number>(1);
  totalResults = 6;

  defaultTableHeaders: DataTableHeaderOption[] = [
    { text: '', key: 'checkbox', width: '0%' },
    { text: this.amountBalance, align: 'right', key: 'amountBalance' },
    { text: this.dueDate, key: 'dueDateObj' },
    { text: this.statementNumber, key: 'statementNumber' },
    { text: this.invoicePeriod, key: 'invoicePeriod' },
    { text: this.billGroup, key: 'billGroup', width: '15%' },
    { text: this.premiumCalc, key: 'premiumCalcObj' },
    { text: '', key: 'seeDetails', width: '15%' },
    { text: this.ActionsText, key: 'actions', width: '5%' }];

  listBillingFancy: CellItemType[] = [
    {
      "amountBalance": 543,
      "amountPaid": 456,
      "amountTotal": 999,
      "billGroupName": "Sacramento",
      "billGroupNumber": "BG-01-020555-00-001",
      "billType": 'Self Admin',
      "dueDate": "03/21/2025",
      "mostRecentPremiumId": "12345",
      "premiumCalc": 'Submitted',
      "premiumCalcUpdatedDate": '2/28/2025',
      "statementStartDate": "3/25/2025",
      "statementEndDate": "3/25/2025",
      "statementNumber": "80050",
      "statementPDFURI": "",
      "selected": false,
      "secondNoticeDays": 35,
      "thirdNoticeDays": 49
    },
    {
      "amountBalance": 657,
      "amountPaid": 456,
      "amountTotal": 233,
      "billGroupName": "Sacramento",
      "billGroupNumber": "BG-01-020555-00-002",
      "billType": 'List Bill',
      "dueDate": "02/21/2025",
      "mostRecentPremiumId": "12345",
      "premiumCalc": 'Not Submitted',
      "premiumCalcUpdatedDate": '',
      "statementStartDate": "2/25/2025",
      "statementEndDate": "3/25/2025",
      "statementNumber": "80051",
      "statementPDFURI": "",
      "selected": false,
      "secondNoticeDays": 35,
      "thirdNoticeDays": 49
    },
    {
      "amountBalance": 777,
      "amountPaid": 456,
      "amountTotal": 233,
      "billGroupName": "Sacramento",
      "billGroupNumber": "BG-01-020555-00-003",
      "billType": 'Self Admin',
      "dueDate": "01/26/2025",
      "mostRecentPremiumId": "12345",
      "premiumCalc": 'Submitted',
      "premiumCalcUpdatedDate": '2/28/2025',
      "statementStartDate": "2/25/2025",
      "statementEndDate": "3/25/2025",
      "statementNumber": "80052",
      "statementPDFURI": "",
      "selected": false,
      "secondNoticeDays": 35,
      "thirdNoticeDays": 49
    },
    {
      "amountBalance": 777,
      "amountPaid": 456,
      "amountTotal": 233,
      "billGroupName": "Sacramento",
      "billGroupNumber": "BG-01-020555-00-003",
      "billType": 'Self Admin',
      "dueDate": "01/15/2025",
      "mostRecentPremiumId": "12345",
      "premiumCalc": 'Submitted',
      "premiumCalcUpdatedDate": '2/28/2025',
      "statementStartDate": "2/25/2025",
      "statementEndDate": "3/25/2025",
      "statementNumber": "80052",
      "statementPDFURI": "",
      "selected": false,
      "secondNoticeDays": 35,
      "thirdNoticeDays": 49
    },
    {
      "amountBalance": 346,
      "amountPaid": 456,
      "amountTotal": 233,
      "billGroupName": "Sacramento",
      "billGroupNumber": "BG-01-020555-00-004",
      "billType": 'Self Admin',
      "dueDate": "01/01/2024",
      "mostRecentPremiumId": "12345",
      "premiumCalc": 'Updated',
      "premiumCalcUpdatedDate": '2/28/2025',
      "statementStartDate": "2/01/2025",
      "statementEndDate": "2/28/2025",
      "statementNumber": "80053",
      "statementPDFURI": "",
      "selected": false,
      "secondNoticeDays": 35,
      "thirdNoticeDays": 49
    }
  ];

  menuItems = [
    {
      showDivider: true,
      label: 'Payment',
      links: [
        {
          text: 'Pay this statement',
          icon: 'attach_money',
          href: 'https://www.google.com',
          newWindow: true
        }
      ]
    },
    {
      label: 'Premium Calculation',
      links: [
        {
          text: 'Make a change',
          icon: 'import_export',
          info: true,
          infoText: 'If there have been changes to personnel or their benefits, you may update lives and volumes to recalculate premium.',
          href: 'https://www.google.com'
        },
        {
          text: 'Report amount shown',
          icon: 'check',
          info: true,
          infoText: 'If there have been no changes to personnel or their benefits, you may proceed to the confirmation page.',
          href: 'https://www.google.com'
        }
      ]
    }
  ]

  // :  Constructor
  constructor(
    private userContextService: UserContextService,
    private billingFancyService: BillingFancyService,
    private fb: UntypedFormBuilder,
    private router: Router,
    private route: ActivatedRoute,

    @Inject(BillingFancyPageComponent) private parent: BillingFancyPageComponent
  ) {
    this.fb = fb;
    this.userContext = this.userContextService.get();
    this.userType = this.userContext.symClass;
    this.formGroup = this.fb.group({
      invoicePeriod: Defaults.stringEmpty,
      status: Defaults.stringEmpty,
      billGroupNumber: Defaults.stringEmpty
    });
    this.tableHeaders = this.defaultTableHeaders;
    this.listBillingFancy = this.transformData(this.listBillingFancy);
    this.onClickTableHeader('dueDate');

  }

  ngOnInit(): void {
  }

  formatDocumentLink(item: string): string {
    return formatActiveEnvironmentDocumentLink(item);
  }

  appendMoreResults() {
    console.log('append');
  }

  async submit() {
    console.log('Submitted');
  }

  onClickTableHeader(sortBy: keyof CellItemType) {
    if (this.searchParameter.sortField === sortBy) {
      if (this.searchParameter.sortDirection?.toLowerCase() === this.SortDirection.Descending?.toLowerCase()) {
        this.searchParameter.sortDirection = this.SortDirection.Ascending;
      } else if (this.searchParameter.sortDirection?.toLowerCase() === this.SortDirection.Ascending?.toLowerCase()) {
        this.searchParameter.sortDirection = this.SortDirection.Descending;
      }
    } else {
      this.searchParameter.sortField = sortBy;
      this.searchParameter.sortDirection = this.SortDirection.Ascending;
    }
    this.listBillingFancy = this.sortTable(this.listBillingFancy, sortBy);
  }


  sortTable(data: CellItemType[], sortBy: keyof CellItemType): CellItemType[] {
    return [...data].sort((a, b) => {
      const valueA = a[sortBy];
      const valueB = b[sortBy];
      // if (sortBy === 'dueDate') {
      //   valueA = new Date(a[sortBy]);
      //   valueB = new Date(b[sortBy]);
      // }
      if (valueA && valueB && (valueA < valueB)) {
        return (this.searchParameter.sortDirection?.toLowerCase() === this.SortDirection.Ascending?.toLowerCase()) ? -1 : 1;
      } else if (valueA && valueB && (valueA > valueB)) {
        return (this.searchParameter.sortDirection?.toLowerCase() === this.SortDirection.Ascending?.toLowerCase()) ? 1 : -1;
      } else {
        return 0;
      }
    });
  }

  onPageChange(page: number) {
    this.page$.next(page);
    this.parent.scrollToTop();
  }

  onPageSizeChange(pageSize: number) {
    this.pageSize$.next(pageSize);
  }

  selectedItems: CellItemType[] = [];

  allSelected = false;

  //selects or deselects all checkboxes
  selectAll(input: boolean) {
    this.allSelected = input;
    this.selectedItems = input ? this.tableCells : [];
    if (input) {
      this.tableCells.forEach((cell) => (cell.selected = true));
    } else {
      this.tableCells.forEach((cell) => (cell.selected = false));
    }
  }

  //selects or deselects individual checkboxes
  selectItem(item: CellItemType, selected: boolean) {
    if (this.allSelected) {
      this.allSelected = false;
    }

    item.selected = selected;
    if (selected) {
      this.selectedItems.push(item);
    } else {
      this.selectedItems = this.selectedItems.filter((listItem) => listItem.statementNumber !== item.statementNumber);
    }
  }

  goStatementDetailPage(item: CellItemType) {
    console.log('item', item);
    this.router.navigate(['/benefits/billing-statements/statement-details'], { relativeTo: this.route });
  }

  dueDateUtil(dueDateString: string, secondNoticeDays: number, thirdNoticeDays: number) {
    const today = new Date();
    const dueDate = new Date(dueDateString);
    const dueDateObject: DueDateObj = {
      text: dueDateString,
      color: '',
      variant: 'bold',
      icon: ''
    }
    const diff = Math.abs(today.getTime() - dueDate.getTime());
    const daysLate = Math.ceil(diff / (1000 * 3600 * 24));
    if (daysLate < secondNoticeDays) {
      dueDateObject.color = 'green';
      dueDateObject.icon = 'hourglass_top';
    } else if (secondNoticeDays <= daysLate && daysLate < thirdNoticeDays) {
      dueDateObject.color = 'yellow';
      dueDateObject.icon = 'hourglass_top';
    } else if (daysLate >= thirdNoticeDays) {
      dueDateObject.color = 'red';
      dueDateObject.icon = 'error';
    }
    return dueDateObject;
  }

  premiumCalcUtil(status: string, premiumCalcUpdatedDate: string) {
    const premiumCalcObject: PremiumCalcObj = {
      text: status,
      color: '',
      appendix: premiumCalcUpdatedDate,
      variant: 'bold',
      icon: '',
      matStyle: ''
    }
    if (status?.toLocaleLowerCase() === 'submitted') {
      premiumCalcObject.color = 'green';
      premiumCalcObject.icon = 'published_with_changes';
    } else if (status?.toLocaleLowerCase() === 'not submitted') {
      premiumCalcObject.color = 'yellow';
      premiumCalcObject.matStyle = 'outlined';
    } else if (status?.toLocaleLowerCase() === 'updated') {
      premiumCalcObject.color = 'purple';
      premiumCalcObject.matStyle = 'outlined';
    }
    return premiumCalcObject;
  }

  invoicePeriodUtil(startDate: string, endDate: string) {
    const startDtMonthYear = this.billingFancyService.formatMonthAndYearDate(startDate);
    const endDtMonthYear = this.billingFancyService.formatMonthAndYearDate(endDate);
    //If months match, then display only one (ex: "February 2025") Else, display both separated by " - " (ex: "January 2025 - March 2025") 
    if (startDtMonthYear !== endDtMonthYear) {
      return startDtMonthYear + ' - ' + endDtMonthYear;
    } else {
      return startDtMonthYear;
    }
  }

  transformData(response: CellItemType[]) {
    response.forEach((element: CellItemType) => {
      element.premiumCalcObj = this.premiumCalcUtil(element.premiumCalc, element.premiumCalcUpdatedDate);
      element.dueDateObj = this.dueDateUtil(element.dueDate, element.secondNoticeDays, element.thirdNoticeDays);
      element.amountBalanceUI = this.billingFancyService.formatAmount(element.amountBalance);
      element.invoicePeriod = this.invoicePeriodUtil(element.statementStartDate, element.statementEndDate);
    });
    console.log('response->', response);
    return response;
  }


}
